import React from "react"
import { useOrder } from "./OrderContext"
import { supabase } from "@/lib/supabase"

import ReactHowler from 'react-howler'
import { useParams } from "react-router-dom"
import { Badge } from "@/components/ui/badge"
import { examples } from "@/cournoyer"
import { removeExtension } from "@/lib/utils"

const DocumentsContext = React.createContext()

export function DocumentsProvider({ children }) {
    const { page } = useParams()
    const { order } = useOrder()

    const sectionsContainer = React.useRef(null)

    const documents = React.useMemo(() => {
        if (order.id) {
            let a = [];

            if (order.mandate?.reviewed) {
                a.push({ value: 'report', label: "Rapport" })
                a.push({ value: 'transcription', label: "Transcription" })
                a.push({ separator: true })
            }

            a = [
                ...a,
                ...order.documents
                    .sort((d1, d2) => {
                        const m1 = order.mandate.path?.includes(d1.name)
                        const m2 = order.mandate.path?.includes(d2.name)
                        return m1 && !m2 ? -1 : !m1 && m2 ? 1 : 0
                    })
                    .map(d => ({
                        value: `${order.company.id}/${order.folder_id}/${d.name}`,
                        label: order.mandate.path?.includes(d.name)
                            ? <>{removeExtension(d.name)} <Badge className="ml-2" variant="outline">Mandat</Badge></>
                            : removeExtension(d.name)
                    }))
            ]

            a = [
                ...a,
                { separator: true },
                ...examples.map(example => ({
                    value: example, label: example.includes('IRSST') ? removeExtension(example) : <>{removeExtension(example)} <Badge className="ml-2" variant="outline">Example</Badge></>
                }))
            ]

            return a
        }
    }, [order?.documents, order?.is_sections_reviewed, order?.suggestions, order?.mandate?.path, order?.mandate?.reviewed, order?.is_transcription_reviewed])


    const [document, setDocument] = React.useState(null)

    React.useEffect(() => {
        if (!document && documents) {
            if (page === 'mandate') {
                setDocument(order?.mandate?.path || documents[0].value)
            } else {
                setDocument('report')
            }
        }
    }, [documents])

    return (
        <DocumentsContext.Provider value={{
            documents, setDocument, document, sectionsContainer
        }}>
            {children}
        </DocumentsContext.Provider>
    )
}

export function useDocuments() {
    const context = React.useContext(DocumentsContext)
    return context
}